import { render, staticRenderFns } from "./index.vue?vue&type=template&id=19b6d255&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=19b6d255&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b6d255",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19b6d255')) {
      api.createRecord('19b6d255', component.options)
    } else {
      api.reload('19b6d255', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=19b6d255&scoped=true", function () {
      api.rerender('19b6d255', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/doc-download/index.vue"
export default component.exports